import find from "lodash/find";
import get from "lodash/get";
import map from "lodash/map";

import DashboardTemplateCard from "../../components/card/dashboardTemplateCard";

const CardSection = ({
  templates,
  templateStats,
  isFullScreen,
  currentTheme,
}) => {
  return (
    <div
      className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 ${
        isFullScreen ? "xl:grid-cols-4" : "xl:grid-cols-3"
      } gap-6 lg:gap-4 xl:gap-4 justify-items-center mx-auto`}
    >
      {map(templates, (template) => {
        const stats = find(templateStats, ["id", get(template, "id")]);
        return (
          <DashboardTemplateCard
            key={get(template, "id")}
            themeClasses={currentTheme}
            template={template}
            stats={stats}
            isFullScreen={isFullScreen}
          />
        );
      })}
    </div>
  );
};

export default CardSection;
